/* eslint-disable import/prefer-default-export */
export const ApiKey = 'ac8970e975713382db0ae18e52198fa1'; // this is a borrowed key'bbce26616140cb78fbac5081d8a07a35'
export const API = 'https://financialmodelingprep.com/api/v3/';
export const ApiKey1 = 'c6f4da6c19a3ecb161aafc2cf9104952';
export const ApiKey2 = 'd4e1991d47f8cfa0f5fcf3655cb78d09';
export const ApiKey3 = '7280e354c9fe19801e27992609e67d30';
export const imgUrlGenerator = (code) => `https://financialmodelingprep.com/image-stock/${code}.png`;
